module.exports = __webpack_public_path__ + "static/media/DASH.d6e6bed9.svg";